import { useMutation, useQueryClient } from "react-query";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import AlarmSetpointsDataService from "../../services/alarm-setpoints-data-service/AlarmSetpointsDataService";
import { IDisabledScheduleDTO } from "../../services/alarm-setpoints-data-service/Models";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { DisabledScheduleMutationContextType } from "./Common";
import { keys } from "./Keys";

export type DisableTagSetpointParameters = {
    groupID: number,
    objectType: eLynxObjectTypeEnum;
    objectID: number;
} & BaseUseMutationParameters<void, IDisabledScheduleDTO>;

export function useDisableObjectSetpoints({
    groupID,
    objectType,
    objectID,
    onError,
    onSuccess
}: DisableTagSetpointParameters) {
    const queryClient = useQueryClient();

    return useMutation<void, RestError, IDisabledScheduleDTO, DisabledScheduleMutationContextType>(
        (schedule) => {
            return AlarmSetpointsDataService.disableObjectSetPoints(
                groupID,
                objectType,
                objectID,
                schedule
            );
        },
        {
            onError: onError,
            onSuccess: onSuccess,
            onSettled: (_data, error, _item, context) => {
                queryClient.invalidateQueries(keys.disableSchedules());
                queryClient.invalidateQueries(keys.lists());
            }
        }
    );
}
